import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface HtmlContent {
  type?: string;
  content?: string;
  href?: string;
}

export interface InformationDialogConfig {
  informationContent: HtmlContent;
  dismissLabel: HtmlContent;
  panelClass?: string;
  parentClass?: string;
  showCloseButton?: boolean;
}

@Component({
  selector: 'ap-information-dialog',
  templateUrl: './information-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationDialogComponent {

  showCloseButton = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: InformationDialogConfig) {
    this.showCloseButton = data.showCloseButton == null ? true : data.showCloseButton;
  }

}
